export default {
    getNote: state =>  {
      return state.note
    }
  }